class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        //  setTimeout(function () {
        // ComparederReInit();
        // }, 2000);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    var compareReInitTimeout = setTimeout(function () {
      clearTimeout(compareReInitTimeout);
           ComparederReInit();
        }, 500);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
       let qty_tot = 1;
    $('.cart-drawer-min .cdmset').each(function(index,item){
        let dataitem = $(this).attr('data');
        if(dataitem){
            if((dataitem == 'DEMO'|| dataitem == 'demo')){
                qty_tot = qty_tot + 1;
            }
        }
    });
    // alert(qty_tot);
    $('.cart-drawer-min .cdmset').each(function(index,item){
      
      //alert(index);
        let dataitem = $(this).attr('data');
        //alert($(this).find(".cdmtitle.fs14").text());
        if(dataitem){
          // if(var_tit.match("^DEMO") && (dataitem == 'DEMO'|| dataitem == 'demo')){
          if((dataitem == 'DEMO'|| dataitem == 'demo')){
           // console.log($(this).find('.cdmtitle').text(), $(this).find('quantity-input').find('input').val());
            //qty_tot = qty_tot + parseInt($(this).find('quantity-input input').val());

           
           
              qty_tot = qty_tot - 1;
            //alert(qty_tot);
             
           // qty_tot = qty_tot + 1;
            //alert($(this).find('.cdmtitle').text());
             // console.log($('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add'));
              $('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-icon-cart-count').text(qty_tot);
              $('#product-grid li .card > .card__content .card__heading a:contains("'+$(this).find('.cdmtitle').text()+'")').parents('.card__content').siblings('.card__inner').find('.quick-add').find('.plus-cart-icon-msg').show()
          }
        }
      });

    var todayDate = new Date().toISOString().slice(0, 10);
    var dt1 = new Date(todayDate);
    //alert(todayDate);
    $(".collection.collection--empty.page-width.emptycat_data").remove();
   /* $('div#ProductGridContainer ul#product-grid li').each(function(index,item){
      if(!$(this).find(".tag_added").length){
         var created_date = $(this).find("span.tag-show").attr("created_date");
       if(created_date != ''){
          var dt2 = new Date(created_date);
          
           var time_difference = dt1 - dt2;
            var result = time_difference / (1000 * 60 * 60 * 24);
           
           if(result <= 90){
            
            var oldtext =  $(this).find("span.tag-show").attr("oldtag");
           
            var newString = oldtext;
           
             if(newString == 'BestSeller' || newString == 'Sale' || newString == 'Best Seller, Sale' || newString == 'Sale, Best Seller'){
              var newtext = newString+", New Release";
              $(this).find("span.tag-show").text(newtext);
            }else{
              $(this).find("span.tag-show").text("New Release");
            }
            $(this).find("span.tag-show").addClass("tag_added");
           }
           
        }

      }
     
      
        });*/

     var mycatArray = [];
     

     if($("div#gscollectionbottom").find("button#gsloadmore").length){
   //   alert("hasbutton");
      $("button#gsloadmore").click();
    }else{
      var found_prod = 0;
      var checkedcol = false;
      $("div#ProductGridContainer ul#product-grid li").each(function(){  
          var product_cats = $(this).attr('prod_collection');
          var showproduct = false;
          $(this).css("display","none");
          var checkedcat = true;
          $("ul#filter_by_cat input").each(function(){  
            if($(this).prop("checked")){
              var catid = $(this).val();
              mycatArray.push(catid);
              if(product_cats.indexOf(catid) != -1){
                showproduct = true;
                 
              }
              checkedcol = true
              checkedcat = false;
            }
          }); 

          if(checkedcat){
            $(this).css("display","block");
          }
          if(showproduct){
             found_prod++;
            $(this).css("display","block");
          }
          //alert(product_cats+'--'+catid);
          
    });  
       if(found_prod == 0 && checkedcol){
        if(!$("div#ProductGridContainer").find(".collection.collection--empty.page-width").length){
          if(!$("div#ProductGridContainer").find(".emptycat_data").length){
            $("div#ProductGridContainer .collection").append('<div class="collection collection--empty page-width emptycat_data" id="product-grid"><div class="title-wrapper center"><h2 class="title title--primary">No products found<br>Use fewer filters or <a class="underlined-link link" href="'+window.location.pathname+'">remove all</a></h2></div></div>');
          }
        }
      }
      //alert(found_prod);
    }
    $(".facets-container").removeClass("overlay-fil");
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }


  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}


customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


$(document).on("click",".close-bbb",function() {
$( "span.mobile-facets__close.mobile-facets__close--no-js" ).trigger( "click" );
});
